import React from 'react';
import { createRoot } from 'react-dom/client';
import PollCampaignApp from './poll/app';
const rootElement = document.getElementById('pollcampaign');
if(rootElement){
    const poll_campaign_id = rootElement.dataset.pollcampaignid
    const root = createRoot(rootElement);
    root.render(
        <PollCampaignApp
            poll_campaign_id={poll_campaign_id ?? ''}
        />
    )
}
